import React from 'react';
import { observer } from 'mobx-react';
import {
    Button,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogContentText,
    DialogActions,
} from '@material-ui/core';
import { useDependencies } from '@servicetitan/react-ioc';
import { ServiceFinanceStore, IDetailField } from '../../../stores/service-finance.store';
import { FinancingPlan } from './financing-plan';
import * as Styles from './details-review-page.less';
import { DetailsReviewItem } from './details-review-item';

export const DetailsReviewPage: React.FC = observer(() => {
    const [store] = useDependencies(ServiceFinanceStore);
    const [isPlanDialogOpen, setIsPlanDialogOpen] = React.useState(false);
    const { goToAddInfoPage, goToSelectPlanPage } = store;
    const loanDetails: IDetailField[][] = [store.getLoanDetails()];
    const applicantDetails: IDetailField[][] = store.getApplicantDetails();
    const coApplicantDetails: IDetailField[][] = store.getCoApplicantDetails();

    return (
        <>
            <Dialog
                fullWidth
                maxWidth="md"
                open={isPlanDialogOpen}
                onClose={() => setIsPlanDialogOpen(false)}
            >
                <DialogTitle>Available Plans</DialogTitle>
                <DialogContent>
                    <DialogContentText id="alert-dialog-description">
                        For your specific needs, here are other financing plans that also qualify:
                    </DialogContentText>
                    {store.selectedPlans.map((plan) => (
                        <FinancingPlan
                            plan={plan}
                            isSelected={
                                store.selectedPlan
                                    ? store.selectedPlan.planNumber === plan.planNumber
                                    : false
                            }
                            loanAmount={store.desiredAmount}
                            selectPlan={(planNumber: string) => {
                                store.selectPlan(planNumber);
                                setIsPlanDialogOpen(false);
                            }}
                            unSelectPlan={store.unSelectPlan}
                        />
                    ))}
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsPlanDialogOpen(false)}>Cancel</Button>
                </DialogActions>
            </Dialog>
            <div className={Styles.container}>
                <div className={Styles.title}>Review Your Information</div>
                <div className={Styles.field}>
                    <span>Plan</span>
                    <a className={Styles.link} onClick={() => setIsPlanDialogOpen(true)}>
                        Change
                    </a>
                </div>
                {store.selectedPlan && (
                    <div className={Styles.plansContainer}>
                        <FinancingPlan
                            isSelected
                            hideAction
                            plan={store.selectedPlan}
                            loanAmount={store.desiredAmount}
                            selectPlan={store.selectPlan}
                            unSelectPlan={store.unSelectPlan}
                        />
                    </div>
                )}
                <DetailsReviewItem
                    header="Loan Details"
                    onClickAction={goToSelectPlanPage}
                    details={loanDetails}
                />
                <DetailsReviewItem
                    header="Applicant Details"
                    onClickAction={goToAddInfoPage}
                    details={applicantDetails}
                />
                {coApplicantDetails.length > 0 && (
                    <DetailsReviewItem
                        header="Co-Applicant Details"
                        onClickAction={goToAddInfoPage}
                        details={coApplicantDetails}
                    />
                )}

                <div className={Styles.followingMessage}>
                    By clicking the Submit Button below, the dealer salesperson submitting this
                    credit application hereby represents and agrees that 1) the dealer salesperson
                    made the applicant(s) aware he or she was applying for credit, (2) the
                    applicant(s) have given their permission to share the information on this credit
                    application with Service Finance Company, (3) the information submitted on the
                    application is true and correct in all respects, (4) the applicant(s) have
                    authorized Service Finance Company to share the information on this credit
                    application with third parties as it deems appropriate, including but not
                    limited to consumer reporting agencies, (5) the applicant(s) have acknowledged
                    and agreed that the information necessary to verify the applicant(s)’s identity
                    will be collected and submitted to Service Finance Company, and (6) that the
                    dealer salesperson submitting the credit application has delivered to the
                    applicant all disclosures required by applicable federal and state law
                </div>
            </div>
        </>
    );
});
